// extracted by mini-css-extract-plugin
export default {"colStyle":"irregularities_colStyle__FSIyQ","colHead":"irregularities_colHead__ZbOW9"};